import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from './AppLayout';
import LandingPage from './LandingPage';
import LegalPolicyPage from './LegalPolicyPage';
import SupportPage from './SupportPage';
import UserProfile from './UserProfile';
import ProductDNA from './ProductDNA';
import './App.css';
import { PonyLinktreePage, PonyPublicPage } from './PonyLinktree';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/profile/:username" element={<UserProfile />} />
          <Route path="/pony-linktree" element={<PonyLinktreePage />} />
          <Route path="/pony/:username" element={<PonyPublicPage />} />
          <Route path="/product-dna" element={<ProductDNA />} />
          <Route path="/product-dna/:productNumber" element={<ProductDNA />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/privacy-policy" element={<LegalPolicyPage policyType="privacy" />} />
          <Route path="/terms-and-conditions" element={<LegalPolicyPage policyType="terms" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
